
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><g clip-path='url(#clip0_17:18123)'><path d='M22.0001 3H7.00008C6.31008 3 5.77008 3.35 5.41008 3.88L0.370078 11.45C0.150078 11.79 0.150078 12.22 0.370078 12.56L5.41008 20.12C5.77008 20.64 6.38008 21 7.07008 21H22.0001C23.1001 21 24.0001 20.1 24.0001 19V5C24.0001 3.9 23.1001 3 22.0001 3ZM9.00008 13.5C8.17008 13.5 7.50008 12.83 7.50008 12C7.50008 11.17 8.17008 10.5 9.00008 10.5C9.83008 10.5 10.5001 11.17 10.5001 12C10.5001 12.83 9.83008 13.5 9.00008 13.5ZM14.0001 13.5C13.1701 13.5 12.5001 12.83 12.5001 12C12.5001 11.17 13.1701 10.5 14.0001 10.5C14.8301 10.5 15.5001 11.17 15.5001 12C15.5001 12.83 14.8301 13.5 14.0001 13.5ZM19.0001 13.5C18.1701 13.5 17.5001 12.83 17.5001 12C17.5001 11.17 18.1701 10.5 19.0001 10.5C19.8301 10.5 20.5001 11.17 20.5001 12C20.5001 12.83 19.8301 13.5 19.0001 13.5Z' fill='#323232'/></g><defs><clipPath id='clip0_17:18123'><rect width='24' height='24' fill='white'/></clipPath></defs></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-more`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconMore

    ```js
    <b-new-b-icon-more />
    ```
</docs>


